import Owner from './Owner';

export default class Ownership {
    id?: number;
    ownerLookUpId?: number;
    horizonId?: number;
    surfaceTractId?: number;
    firstName?: string;
    lastName?: string;
    ownershipType?: string;
    decimalInterest?: number;
    executiveRights?: number;
    isLeased?: boolean;
    ownershipTypeId?: number;
    addressLine1?: string;
    parentOwnershipId?: number;
    leaseBuyer?: number;
    contactCategory?: string;
    ownershipContactCategoryId?: number;
    leasedStatus?: string;
    activeLeaseTypes?: Array<string>;
    additionalOwnershipTypeId?: number;
    additionalOwnerships?: Array<Ownership>;
    note?: string;
    isWIClientAcreage?: boolean;
    ownerInfo?: Owner;
    isCommunityProperty?: boolean;

    // not mapped
    netAcres?: number;
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/Ownership.ts